//src/admin/ExamPage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
const EXAMS_API = `${BASE_URL}/api/exams`;
const CHECK_EXAM_NAME_API = `${BASE_URL}/api/exams/check-exam-name`;
const SUBJECTS_API = `${BASE_URL}/api/subjects/filtersubjects`;
const COURSES_API = `${BASE_URL}/api/course`;
const CLASSES_API = `${BASE_URL}/api/classes`;
const ACADEMICYEARS_API = `${BASE_URL}/api/academic-yearsss`; // new
const ExamPage = () => {
  const [formData, setFormData] = useState({
    ExamName: "",
    SubjectIDs: [],
    CourseID: "",
     //SectionID: "",
    ClassID: "",
    AcademicYearID: "",
    MinMarks: "",
    TotalMarks: "",
    CreatedBy: "admin",
    CreatedDate: new Date().toISOString().split("T")[0],
    UpdatedBy: null,
    UpdatedDate: null,
  });
  const [courses, setCourses] = useState([]);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
 const [academicYears, setAcademicYears] = useState([]);
 const [sections, setSections] = useState([]);
 const [hasSections, setHasSections] =useState(false);
  useEffect(() => {
    axios.get(COURSES_API).then((res) => setCourses(res.data));
  }, []);
// load academic years for selected course
  useEffect(() => {
    if (formData.CourseID) {
      axios.get(`${ACADEMICYEARS_API}?course=${formData.CourseID}`)
        .then((res) => setAcademicYears(res.data));
    } else {
      setAcademicYears([]);
    }
  }, [formData.CourseID]);
  useEffect(() => {
    if (formData.CourseID) {
      axios.get(`${CLASSES_API}?course=${formData.CourseID}`).then((res) => {
        const classData = res.data.map((c) => ({
          ClassID: c.ClassID || c.id,
          name: c.name,
        }));
        setClasses(classData);
      });
    }
  }, [formData.CourseID]);
  useEffect(() => {
    if (formData.CourseID && formData.ClassID) {
      axios
        .get(`${SUBJECTS_API}?courseID=${formData.CourseID}&classID=${formData.ClassID}`)
        .then((res) => setSubjects(res.data));
    }
  }, [formData.CourseID, formData.ClassID]);
  //Load Section for Class
  useEffect(() => {
    if (!formData.ClassID) {
        setSections([]);
        setHasSections(false);
        setFormData(prev => ({
            ...prev,
            SectionID: null
        }));
        return;
    }

    axios
        .get(`${BASE_URL}/api/sections/${formData.ClassID}`)
        .then(res => {

            if (res.data.length > 0) {
                setSections(res.data);
                setHasSections(true);

                setFormData(prev => ({
                    ...prev,
                    SectionID: ""
                }));
            } else {

                // No sections

                setSections([]);
                setHasSections(false);

                setFormData(prev => ({
                    ...prev,
                    SectionID: null
                }));
            }

        });

}, [formData.ClassID]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubjectCheckbox = (subjectId) => {
    setFormData((prev) => {
      const alreadySelected = prev.SubjectIDs.includes(subjectId);
      return {
        ...prev,
        SubjectIDs: alreadySelected
          ? prev.SubjectIDs.filter((id) => id !== subjectId)
          : [...prev.SubjectIDs, subjectId],
      };
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // Step 1: Check if exam name exists
    axios
      .post(CHECK_EXAM_NAME_API, { 
        ExamName: formData.ExamName,
        AcademicYearID: formData.AcademicYearID,
        CourseID: formData.CourseID,
        ClassID: formData.ClassID,
        //SectionID: formData.SectionID,
         SectionID: hasSections ? formData.SectionID : null
      })
      .then((res) => {
        if (res.data.exists) {
          alert("Exam name already exists. Please choose a different name.");
        } else {
          // Step 2: Proceed to create the exam
          /* axios
            .post(EXAMS_API, formData) */
            axios.post(EXAMS_API,{
    ...formData,
    SectionID: hasSections ? formData.SectionID : null
})
            .then(() => {
              alert("Exam created successfully!");
              setFormData({
                ExamName: "",
                SubjectIDs: [],
                CourseID: "",
                ClassID: "",
                SectionID: "",
                AcademicYearID: "",
                MinMarks: "",
                TotalMarks: "",
                CreatedBy: "admin",
                CreatedDate: new Date().toISOString().split("T")[0],
                UpdatedBy: null,
                UpdatedDate: null,
              });
              setSubjects([]);
              setClasses([]);
              setAcademicYears([]);
            })
            .catch((error) => {
              console.error(error);
              alert("Error creating exam.");
            });
        }
      })
      .catch((error) => { 
        alert("Exam name alredy Exist!.");
      });
  };
  return (
    <div className="container mt-5">
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-body p-5">
          <h2 className="card-title mb-4 text-center">Create New Exam</h2>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Exam Name</label>
                <input
                  type="text"
                  name="ExamName"
                  value={formData.ExamName}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Course</label>
                <select
                  name="CourseID"
                  value={formData.CourseID}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Select Course</option>
                  {courses.map((c) => (
                    <option key={c.CourseID} value={c.CourseID}>
                      {c.CourseName}
                    </option>
                  ))}
                </select>
              </div>
 {/* Academic Year */}
              <div className="col-md-6">
                <label className="form-label">Academic Year</label>
                <select
                  name="AcademicYearID"
                  value={formData.AcademicYearID}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Select Academic Year</option>
                  {academicYears.map((y) => (
                    <option key={y.id} value={y.id}>
                      {y.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Class</label>
                <select
                  name="ClassID"
                  value={formData.ClassID}
                  onChange={handleChange}
                  className="form-select rounded-3"
                  required
                >
                  <option value="">Select Class</option>
                  {classes.map((c) => (
                    <option key={c.ClassID} value={c.ClassID}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </div>
              {hasSections && (
<div className="col-md-6">
<label className="form-label">
Section
</label>
<select
    name="SectionID"
    value={formData.SectionID || ""}
    onChange={handleChange}
    className="form-select"
    required
>
<option value="">
Select Section
</option>

{sections.map(sec=>(
<option
key={sec.SectionID}
value={sec.SectionID}
>
{sec.SectionName}
</option>
))}
</select>
</div>
)}
              <div className="col-md-6">
                <label className="form-label">Subjects</label>
                <div className="border rounded-3 p-3" style={{ maxHeight: 200, overflowY: "auto" }}>
                  {subjects.length === 0 ? (
                    <p className="text-muted">No subjects available.</p>
                  ) : (
                    subjects.map((s) => (
                      <div key={s.SubjectID} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`subject-${s.SubjectID}`}
                          checked={formData.SubjectIDs.includes(s.SubjectID)}
                          onChange={() => handleSubjectCheckbox(s.SubjectID)}
                        />
                        <label className="form-check-label" htmlFor={`subject-${s.SubjectID}`}>
                          {s.SubjectName}
                        </label>
                      </div>
                    ))
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <label className="form-label">Min Marks</label>
                <input
                  type="number"
                  name="MinMarks"
                  value={formData.MinMarks}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Total Marks</label>
                <input
                  type="number"
                  name="TotalMarks"
                  value={formData.TotalMarks}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  required
                />
              </div>
            </div>
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary px-4 py-2 rounded-pill shadow-sm">
                Create Exam
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default ExamPage;
